<template>
    <header class="headbar">
        <div class="left-buttons">
            <!-- File 下拉菜单 -->
            <el-dropdown @command="handleFileCommand">
                <button class="headbar-button" :class="{ active: activeButton === 'File' }">
                    {{ $t('headbar.file') }} <i class="el-icon-arrow-down el-icon--right"></i>
                </button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="import-txt">{{ $t('headbar.fileMenu.importTxt') }}</el-dropdown-item>
                    <el-dropdown-item command="export-svg">{{ $t('headbar.fileMenu.exportSvg') }}</el-dropdown-item>
                    <el-dropdown-item command="export-pdf">{{ $t('headbar.fileMenu.exportPdf') }}</el-dropdown-item>
                    <el-dropdown-item command="export-txt">{{ $t('headbar.fileMenu.exportTxt') }}</el-dropdown-item>
                    <el-dropdown-item command="jianpu-converter">{{ $t('headbar.jianpuConverter.title')
                        }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <!-- Insert 按钮 -->
            <!-- <button 
                v-for="btn in buttons" 
                :key="btn" 
                :class="['headbar-button', { active: activeButton === btn }]" 
                @click="setActive(btn)" 
            >
                {{ btn }}
            </button> -->

            <!-- Mode 二级菜单 -->
            <el-button-group class="mode-selector">
                <el-button v-for="mode in modes" :key="mode.command"
                    :type="currentMode === mode.command ? 'primary' : ''" @click="setMode(mode.command)">
                    <i :class="getModeIcon(mode.command)"></i>
                    {{ $t(`headbar.modeOptions.${mode.command}`) }}
                </el-button>
            </el-button-group>

            <!-- 添加两个switch -->
            <el-switch v-model="manualLayoutValue" :active-text="$t('headbar.manualLayout')" inactive-text=""
                class="mode-switch" />
            <el-switch v-model="showFingeringsValue" :active-text="$t('headbar.fingeringAnnotation')" inactive-text=""
                class="mode-switch" />
        </div>
        <div class="right-buttons">
            <button class="headbar-button layout-button" @click="toggleLayout">{{ $t('headbar.layout') }}</button>
            <i class="el-icon-setting user-icon" @click="openSettings"></i>
            <i class="el-icon-info user-icon" @click="openInfo"></i>
            <el-dropdown @command="handleLanguageChange" class="language-dropdown">
                <i class="el-icon-guide user-icon"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="zh" :class="{ 'active-language': currentLanguage === 'zh' }">
                        中文
                    </el-dropdown-item>
                    <el-dropdown-item command="en" :class="{ 'active-language': currentLanguage === 'en' }">
                        English
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <!-- Configuration Dialog -->
        <el-dialog :title="$t('headbar.settings.title')" :visible.sync="isSettingsDialogVisible" width="720px"
            custom-class="settings-dialog">

            <el-form :model="settings">
                <el-tabs type="card">
                    <!-- 页面设置 -->
                    <el-tab-pane :label="$t('headbar.settings.tabs.page')">
                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-document"></i>
                                <span>{{ $t('headbar.settings.page.paperAndMargin') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.page.paperSize')">
                                    <el-select v-model="settings.paperSize"
                                        :placeholder="$t('headbar.settings.page.selectPaper')">
                                        <el-option label="A4（210mm x 297mm）" value="A4"></el-option>
                                        <el-option label="US-Letter（8.5in x 11in）" value="US"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.page.marginSettings')">
                                    <div class="margin-inputs">
                                        <el-input-number v-model="settings.margin.top" controls-position="right"
                                            size="small"
                                            :placeholder="$t('headbar.settings.page.margins.top')"></el-input-number>
                                        <el-input-number v-model="settings.margin.right" controls-position="right"
                                            size="small"
                                            placeholder="$t('headbar.settings.page.margins.right')"></el-input-number>
                                        <el-input-number v-model="settings.margin.bottom" controls-position="right"
                                            size="small"
                                            placeholder="$t('headbar.settings.page.margins.bottom')"></el-input-number>
                                        <el-input-number v-model="settings.margin.left" controls-position="right"
                                            size="small"
                                            :placeholder="$t('headbar.settings.page.margins.left')"></el-input-number>
                                    </div>
                                </el-form-item>
                            </div>
                        </div>

                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-position"></i>
                                <span>{{ $t('headbar.settings.page.spacingSettings') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.page.topSpacing')">
                                    <el-input-number v-model="settings.spacing.songTop"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.page.lyricsSpacing')">
                                    <el-input-number v-model="settings.spacing.songBottom"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.page.fingeringSpacing')">
                                    <el-input-number v-model="settings.spacing.fingeringsBottom"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                            </div>
                        </div>
                    </el-tab-pane>

                    <!-- 字体设置 -->
                    <el-tab-pane :label="$t('headbar.settings.tabs.font')">
                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-edit"></i>
                                <span>{{ $t('headbar.settings.font.titleStyle') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.common.font')">
                                    <el-select v-model="settings.titleFont">
                                        <el-option :label="$t('headbar.settings.font.options.default')"
                                            value="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.songti')"
                                            value="'CustomSong', 'Noto Serif SC', 'Songti SC', 'Ming Light', 'SimSun', 'STSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.heiti')"
                                            value="'CustomHei', 'Noto Sans SC', 'Heiti SC', 'Microsoft YaHei', 'SimHei', 'STHeiti', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.kaiti')"
                                            value="'CustomKai', 'LXGW WenKai', 'Kaiti SC', 'KaiTi', 'STKaiti', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.fangsong')"
                                            value="'CustomFangSong', 'FangSong', 'STFangSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.yuanti')"
                                            value="'CustomYuanTi', 'YouYuan', 'STYuanTi', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.xingkai')"
                                            value="'CustomXingKai', 'STXingkai', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.calligraphy')"
                                            value="'CustomCalligraphy', 'STCaiyun', serif"></el-option>

                                        <!-- 添加一些英文字体 -->
                                        <el-option label="Arial" value='"Arial", sans-serif'></el-option>
                                        <el-option label="Times New Roman" value='"Times New Roman", serif'></el-option>
                                        <el-option label="Courier New" value='"Courier New", monospace'></el-option>
                                        <el-option label="Verdana" value='"Verdana", sans-serif'></el-option>
                                        <el-option label="Georgia" value='"Georgia", serif'></el-option>
                                        <el-option label="Tahoma" value='"Tahoma", sans-serif'></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.size')">
                                    <el-input-number v-model="settings.fontSize.title"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.color')">
                                    <el-color-picker v-model="settings.titleColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.style')">
                                    <el-checkbox v-model="settings.titleBold">{{ $t('headbar.settings.common.bold')
                                    }}</el-checkbox>
                                    <el-checkbox v-model="settings.titleItalic">{{ $t('headbar.settings.common.italic')
                                    }}</el-checkbox>
                                </el-form-item>
                            </div>
                        </div>

                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-edit"></i>
                                <span>{{ $t('headbar.settings.font.keyStyle') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.common.font')">
                                    <el-select v-model="settings.fingeringsFont">
                                        <el-option :label="$t('headbar.settings.font.options.default')"
                                            value="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.songti')"
                                            value="'CustomSong', 'Noto Serif SC', 'Songti SC', 'Ming Light', 'SimSun', 'STSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.heiti')"
                                            value="'CustomHei', 'Noto Sans SC', 'Heiti SC', 'Microsoft YaHei', 'SimHei', 'STHeiti', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.kaiti')"
                                            value="'CustomKai', 'LXGW WenKai', 'Kaiti SC', 'KaiTi', 'STKaiti', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.fangsong')"
                                            value="'CustomFangSong', 'FangSong', 'STFangSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.yuanti')"
                                            value="'CustomYuanTi', 'YouYuan', 'STYuanTi', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.xingkai')"
                                            value="'CustomXingKai', 'STXingkai', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.calligraphy')"
                                            value="'CustomCalligraphy', 'STCaiyun', serif"></el-option>

                                        <!-- 添加一些英文字体 -->
                                        <el-option label="Arial" value='"Arial", sans-serif'></el-option>
                                        <el-option label="Times New Roman" value='"Times New Roman", serif'></el-option>
                                        <el-option label="Courier New" value='"Courier New", monospace'></el-option>
                                        <el-option label="Verdana" value='"Verdana", sans-serif'></el-option>
                                        <el-option label="Georgia" value='"Georgia", serif'></el-option>
                                        <el-option label="Tahoma" value='"Tahoma", sans-serif'></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.size')">
                                    <el-input-number v-model="settings.fontSize.fingerings"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.color')">
                                    <el-color-picker v-model="settings.fingeringsColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.style')">
                                    <el-checkbox v-model="settings.fingeringsBold">{{ $t('headbar.settings.common.bold')
                                    }}</el-checkbox>
                                    <el-checkbox v-model="settings.fingeringsItalic">{{
                                        $t('headbar.settings.common.italic') }}</el-checkbox>
                                </el-form-item>
                            </div>
                        </div>
                    </el-tab-pane>

                    <!-- 琴卷设置 -->
                    <el-tab-pane :label="$t('headbar.settings.tabs.roll')">
                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-s-operation"></i>
                                <span>{{ $t('headbar.settings.roll.basic') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.roll.rollHeight')">
                                    <el-input-number v-model="settings.rollBarWidth"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.roll.beatsPerLine')">
                                    <el-input-number v-model="settings.beatNum"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                            </div>
                        </div>

                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-picture-outline"></i>
                                <span>{{ $t('headbar.settings.roll.appearance') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.roll.rollColor1')">
                                    <el-color-picker v-model="settings.rollBarColor1" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.roll.rollColor2')">
                                    <el-color-picker v-model="settings.rollBarColor2" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.roll.noteStroke')">
                                    <el-color-picker v-model="settings.noteStrokeColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.roll.noteFill')">
                                    <el-color-picker v-model="settings.noteFillColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.roll.triangleStroke')">
                                    <el-color-picker v-model="settings.triangleStrokeColor"
                                        show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.roll.triangleFill')">
                                    <el-color-picker v-model="settings.triangleFillColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.roll.positionColor')">
                                    <el-color-picker v-model="settings.positionColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.roll.positionFont')">
                                    <el-select v-model="settings.positionFont">
                                        <el-option :label="$t('headbar.settings.font.options.default')"
                                            value="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.songti')"
                                            value="'CustomSong', 'Noto Serif SC', 'Songti SC', 'Ming Light', 'SimSun', 'STSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.heiti')"
                                            value="'CustomHei', 'Noto Sans SC', 'Heiti SC', 'Microsoft YaHei', 'SimHei', 'STHeiti', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.kaiti')"
                                            value="'CustomKai', 'LXGW WenKai', 'Kaiti SC', 'KaiTi', 'STKaiti', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.fangsong')"
                                            value="'CustomFangSong', 'FangSong', 'STFangSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.yuanti')"
                                            value="'CustomYuanTi', 'YouYuan', 'STYuanTi', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.xingkai')"
                                            value="'CustomXingKai', 'STXingkai', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.calligraphy')"
                                            value="'CustomCalligraphy', 'STCaiyun', serif"></el-option>

                                        <!-- 添加一些英文字体 -->
                                        <el-option label="Arial" value='"Arial", sans-serif'></el-option>
                                        <el-option label="Times New Roman" value='"Times New Roman", serif'></el-option>
                                        <el-option label="Courier New" value='"Courier New", monospace'></el-option>
                                        <el-option label="Verdana" value='"Verdana", sans-serif'></el-option>
                                        <el-option label="Georgia" value='"Georgia", serif'></el-option>
                                        <el-option label="Tahoma" value='"Tahoma", sans-serif'></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.style')">
                                    <el-checkbox v-model="settings.piaonHuiBold">{{ $t('headbar.settings.common.bold')
                                    }}</el-checkbox>
                                    <el-checkbox v-model="settings.piaonHuiItalic">{{
                                        $t('headbar.settings.common.italic') }}</el-checkbox>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.size')">
                                    <el-radio-group v-model="settings.positionSize">
                                        <el-radio :value="3" label="small">{{ $t('headbar.settings.size.small')
                                        }}</el-radio>
                                        <el-radio :value="6" label="medium">{{ $t('headbar.settings.size.medium')
                                        }}</el-radio>
                                        <el-radio :value="9" label="large">{{ $t('headbar.settings.size.large')
                                        }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.roll.noteCorner')">
                                    <el-radio-group v-model="settings.noteCornerStyle">
                                        <el-radio label="rounded">{{ $t('headbar.settings.roll.cornerRounded')
                                        }}</el-radio>
                                        <el-radio label="square">{{ $t('headbar.settings.roll.cornerSquare')
                                        }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </el-tab-pane>

                    <!-- 七线设置 -->
                    <el-tab-pane :label="$t('headbar.settings.tabs.lines')">
                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-menu"></i>
                                <span>{{ $t('headbar.settings.lines.basic') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.lines.lineSpacing')">
                                    <el-input-number v-model="settings.stringSpacing"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.lines.notesPerLine')">
                                    <el-input-number v-model="settings.noteNum"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-picture-outline"></i>
                                <span>{{ $t('headbar.settings.lines.appearance') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.lines.thickLine')">
                                    <el-color-picker v-model="settings.lineColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.lines.thinLine')">
                                    <el-color-picker v-model="settings.lineBoldColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.lines.triangleStroke')">
                                    <el-color-picker v-model="settings.lineTriangleStrokeColor"
                                        show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.lines.triangleFill')">
                                    <el-color-picker v-model="settings.lineTriangleFillColor"
                                        show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.lines.positionColor')">
                                    <el-color-picker v-model="settings.linePositionColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.lines.positionFont')">
                                    <el-select v-model="settings.linePositionFont">
                                        <el-option :label="$t('headbar.settings.font.options.default')"
                                            value="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.songti')"
                                            value="'CustomSong', 'Noto Serif SC', 'Songti SC', 'Ming Light', 'SimSun', 'STSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.heiti')"
                                            value="'CustomHei', 'Noto Sans SC', 'Heiti SC', 'Microsoft YaHei', 'SimHei', 'STHeiti', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.kaiti')"
                                            value="'CustomKai', 'LXGW WenKai', 'Kaiti SC', 'KaiTi', 'STKaiti', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.fangsong')"
                                            value="'CustomFangSong', 'FangSong', 'STFangSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.yuanti')"
                                            value="'CustomYuanTi', 'YouYuan', 'STYuanTi', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.xingkai')"
                                            value="'CustomXingKai', 'STXingkai', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.calligraphy')"
                                            value="'CustomCalligraphy', 'STCaiyun', serif"></el-option>

                                        <!-- 添加一些英文字体 -->
                                        <el-option label="Arial" value='"Arial", sans-serif'></el-option>
                                        <el-option label="Times New Roman" value='"Times New Roman", serif'></el-option>
                                        <el-option label="Courier New" value='"Courier New", monospace'></el-option>
                                        <el-option label="Verdana" value='"Verdana", sans-serif'></el-option>
                                        <el-option label="Georgia" value='"Georgia", serif'></el-option>
                                        <el-option label="Tahoma" value='"Tahoma", sans-serif'></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.style')">
                                    <el-checkbox v-model="settings.lineHuiBold">{{ $t('headbar.settings.common.bold')
                                    }}</el-checkbox>
                                    <el-checkbox v-model="settings.lineHuiItalic">{{
                                        $t('headbar.settings.common.italic') }}</el-checkbox>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.size')">
                                    <el-radio-group v-model="settings.linePositionSize">
                                        <el-radio :value="3" label="small">{{ $t('headbar.settings.size.small')
                                        }}</el-radio>
                                        <el-radio :value="6" label="medium">{{ $t('headbar.settings.size.medium')
                                        }}</el-radio>
                                        <el-radio :value="9" label="large">{{ $t('headbar.settings.size.large')
                                        }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </el-tab-pane>

                    <!-- 歌词设置 -->
                    <el-tab-pane :label="$t('headbar.settings.tabs.lyrics')">
                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-reading"></i>
                                <span>{{ $t('headbar.settings.lyrics.style') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.common.font')">
                                    <el-select v-model="settings.lyricsFont">
                                        <el-option :label="$t('headbar.settings.font.options.default')"
                                            value="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.songti')"
                                            value="'CustomSong', 'Noto Serif SC', 'Songti SC', 'Ming Light', 'SimSun', 'STSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.heiti')"
                                            value="'CustomHei', 'Noto Sans SC', 'Heiti SC', 'Microsoft YaHei', 'SimHei', 'STHeiti', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.kaiti')"
                                            value="'LXGW WenKai', 'Kaiti SC', 'KaiTi', 'STKaiti', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.fangsong')"
                                            value="'CustomFangSong', 'FangSong', 'STFangSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.yuanti')"
                                            value="'CustomYuanTi', 'YouYuan', 'STYuanTi', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.xingkai')"
                                            value="'CustomXingKai', 'STXingkai', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.calligraphy')"
                                            value="'CustomCalligraphy', 'STCaiyun', serif"></el-option>

                                        <!-- 添加一些英文字体 -->
                                        <el-option label="Arial" value='"Arial", sans-serif'></el-option>
                                        <el-option label="Times New Roman" value='"Times New Roman", serif'></el-option>
                                        <el-option label="Courier New" value='"Courier New", monospace'></el-option>
                                        <el-option label="Verdana" value='"Verdana", sans-serif'></el-option>
                                        <el-option label="Georgia" value='"Georgia", serif'></el-option>
                                        <el-option label="Tahoma" value='"Tahoma", sans-serif'></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.size')">
                                    <el-input-number v-model="settings.fontSize.lyrics"
                                        controls-position="right"></el-input-number>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.color')">
                                    <el-color-picker v-model="settings.lyricsColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.style')">
                                    <el-checkbox v-model="settings.lyricsBold">{{ $t('headbar.settings.common.bold')
                                    }}</el-checkbox>
                                    <el-checkbox v-model="settings.lyricsItalic">{{ $t('headbar.settings.common.italic')
                                    }}</el-checkbox>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.align')">
                                    <el-radio-group v-model="settings.lyricsAlign">
                                        <el-radio :value="3" label="left">{{ $t('headbar.settings.align.left')
                                        }}</el-radio>
                                        <el-radio :value="6" label="center">{{ $t('headbar.settings.align.center')
                                        }}</el-radio>
                                        <el-radio :value="9" label="right">{{ $t('headbar.settings.align.right')
                                        }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </el-tab-pane>

                    <!-- 指法设置 -->
                    <el-tab-pane :label="$t('headbar.settings.tabs.finger')">
                        <div class="settings-section">
                            <div class="section-header">
                                <i class="el-icon-thumb"></i>
                                <span>{{ $t('headbar.settings.finger.style') }}</span>
                            </div>
                            <div class="settings-grid">
                                <el-form-item :label="$t('headbar.settings.common.font')">
                                    <el-select v-model="settings.fingersFont">
                                        <el-option :label="$t('headbar.settings.font.options.default')"
                                            value="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.songti')"
                                            value="'CustomSong', 'Noto Serif SC', 'Songti SC', 'Ming Light', 'SimSun', 'STSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.heiti')"
                                            value="'CustomHei', 'Noto Sans SC', 'Heiti SC', 'Microsoft YaHei', 'SimHei', 'STHeiti', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.kaiti')"
                                            value="'LXGW WenKai', 'Kaiti SC', 'KaiTi', 'STKaiti', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.fangsong')"
                                            value="'CustomFangSong', 'FangSong', 'STFangSong', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.yuanti')"
                                            value="'CustomYuanTi', 'YouYuan', 'STYuanTi', sans-serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.xingkai')"
                                            value="'CustomXingKai', 'STXingkai', serif"></el-option>
                                        <el-option :label="$t('headbar.settings.font.options.calligraphy')"
                                            value="'CustomCalligraphy', 'STCaiyun', serif"></el-option>

                                        <!-- 添加一些英文字体 -->
                                        <el-option label="Arial" value='"Arial", sans-serif'></el-option>
                                        <el-option label="Times New Roman" value='"Times New Roman", serif'></el-option>
                                        <el-option label="Courier New" value='"Courier New", monospace'></el-option>
                                        <el-option label="Verdana" value='"Verdana", sans-serif'></el-option>
                                        <el-option label="Georgia" value='"Georgia", serif'></el-option>
                                        <el-option label="Tahoma" value='"Tahoma", sans-serif'></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.color')">
                                    <el-color-picker v-model="settings.fingersColor" show-alpha></el-color-picker>
                                </el-form-item>
                                <el-form-item :label="$t('headbar.settings.common.style')">
                                    <el-checkbox v-model="settings.fingersBold">{{ $t('headbar.settings.common.bold')
                                    }}</el-checkbox>
                                    <el-checkbox v-model="settings.fingersItalic">{{
                                        $t('headbar.settings.common.italic') }}</el-checkbox>
                                </el-form-item>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="resetSettings" type="warning" plain>
                    <i class="el-icon-refresh-left"></i>
                    {{ $t('headbar.settings.reset') }}
                </el-button>
                <el-button @click="cancelSettings" plain>
                    {{ $t('headbar.settings.cancel') }}
                </el-button>
                <el-button type="primary" @click="saveSettings">
                    {{ $t('headbar.settings.save') }}
                </el-button>
            </div>
        </el-dialog>


        <el-dialog :title="$t('headbar.help.title')" :visible.sync="showDialog">
            <!-- 输入结构 -->
            <el-alert :title="$t('headbar.help.structure')" type="info" :closable="false">
                <pre># 以下为描述头定义
                B: [在此输入曲谱标题]
                D: [在此输入调号] <el-tag type="info" size="mini">单值/七值</el-tag>

                # 以下为谱子主体
                [在此输入减字谱]

                # 以下为歌词
                [在此输入歌词]</pre>

                <div class="tip">
                    <p>⚠️ 调号输入说明：</p>
                    <ul>
                        <li>输入<el-tag size="mini">1个值</el-tag>时为标准定调（如 <code>D: F</code>）</li>
                        <li>输入<el-tag size="mini" type="danger">7个值</el-tag>时为七弦独立定调（如 <code>D: 一弦 二弦 三弦...七弦</code>）
                        </li>
                    </ul>
                    <p>⚠️ 请勿删除带#号的分区文字</p>
                </div>
            </el-alert>

            <!-- 减字输入 -->
            <el-alert :title="$t('headbar.help.inputRules')" type="warning" :closable="false">
                <ul>
                    <li>用减字读谱方式输入，没有规定的指法输入顺序</li>
                    <li>减字间用<el-tag size="mini">空格</el-tag>分隔，例：<code>挑六 勺七 0</code></li>
                    <li>休止符使用数字<el-tag size="mini" type="danger">0</el-tag></li>
                    <li>减字节奏与减字间不需要空格</li>
                </ul>
            </el-alert>

            <!-- 节奏符号 -->
            <el-alert :title="$t('headbar.help.rhythmSymbols')" type="success" :closable="false">
                <el-row :gutter="24">
                    <el-col :span="6" style="white-space: nowrap">\ 半拍</el-col>
                    <el-col :span="6" style="white-space: nowrap">. 附点</el-col>
                    <el-col :span="6" style="white-space: nowrap">- 延音线</el-col>
                    <el-col :span="6" style="white-space: nowrap">| 小节线</el-col>
                </el-row>
                <p class="example">示例：<code>六\ 五. 六- |</code></p>
            </el-alert>

            <!-- 歌词输入 -->
            <el-alert :title="$t('headbar.help.lyricsRules')" type="error" :closable="false">
                <ul>
                    <li>歌词与减字<el-tag size="mini">一一对应</el-tag></li>
                    <li>空格分隔歌词，例：<code>春风 细雨 -</code></li>
                    <li>无歌词处用<code>-</code>占位</li>
                </ul>
            </el-alert>

            <!-- 排版设置 -->
            <el-alert :title="$t('headbar.help.layoutModes')" type="info" :closable="false">
                <el-row :gutter="16">
                    <el-col :span="12" style="white-space: nowrap">
                        <h4>自动排版 <el-tag size="mini">推荐</el-tag></h4>
                        <ul>
                            <li>在右上角 <el-icon>
                                    <setting />
                                </el-icon> 设置中配置</li>
                            <li>固定每行显示 <code>X</code> 个音符</li>
                            <li>输入时无需换行，系统自动折行</li>
                        </ul>
                    </el-col>

                    <el-col :span="12" style="white-space: nowrap">
                        <h4>手动排版</h4>
                        <ul>
                            <li>在输入区按 <el-tag size="mini">回车键</el-tag> 换行</li>
                            <li>乐谱显示与输入区 <el-tag type="success">完全同步</el-tag></li>
                            <li>支持自由定义每行数量</li>
                        </ul>
                    </el-col>
                </el-row>
            </el-alert>

            <div slot="footer">
                <el-button @click="showDialog = false">{{ $t('headbar.help.close') }}</el-button>
            </div>
        </el-dialog>

        <!-- 简谱转换对话框 -->
        <el-dialog :title="$t('headbar.jianpuConverter.title')" :visible.sync="showJianpuConverterDialog" width="600px">
            <el-form>
                <el-form-item :label="$t('headbar.jianpuConverter.jianpuInput')">
                    <el-input type="textarea" :rows="6" :placeholder="$t('headbar.jianpuConverter.jianpuPlaceholder')"
                        v-model="jianpuInput"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer">
                <el-button @click="showJianpuConverterDialog = false">
                    {{ $t('headbar.jianpuConverter.cancel') }}
                </el-button>
                <el-button type="primary" @click="convertJianpu">
                    {{ $t('headbar.jianpuConverter.convert') }}
                </el-button>
            </div>
        </el-dialog>

    </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { findPitchPositions } from '../assets/PitchMap';

export default {
    name: "HeadBar",
    data() {
        return {
            buttons: ["Insert"],
            activeButton: "File",
            isSettingsDialogVisible: false,
            showDialog: false,
            modes: [
                { command: "piano-roll" },
                { command: "guitar-tablature" },
            ],
            currentLanguage: localStorage.getItem('language') || 'zh',
            showJianpuConverterDialog: false,
            jianpuInput: '',
            previousNotes: [], // 用于追踪最近的音符
            totalDuration: 0,
        };
    },
    computed: {
        ...mapGetters(["currentMode"]),
        settings: {
            get() {
                return this.$store.getters.settings;
            },
            set(value) {
                this.setSettings(value);
            }
        },
        manualLayoutValue: {
            get() {
                return this.$store.state.manualLayout;
            },
            set(value) {
                this.$store.commit('setManualLayout', value);
            }
        },
        showFingeringsValue: {
            get() {
                return this.$store.state.showFingerings;
            },
            set(value) {
                this.$store.commit('setShowFingerings', value);
            }
        },
        layoutMode() {
            return this.$store.state.layoutMode;
        },
        layoutButtonText() {
            const modes = {
                'split': 'Split View',
                'tablature': 'Editor Only',
                'sidebar': 'Preview Only'
            };
            return modes[this.layoutMode];
        },
    },
    methods: {
        ...mapActions(["setSettings", "changeMode", "resetToDefault"]),
        setActive(btn) {
            this.activeButton = btn;
        },
        openSettings() {
            this.isSettingsDialogVisible = true;
        },
        openInfo() {
            this.showDialog = true;
        },
        openJianpuConverter() {
            this.showJianpuConverterDialog = true;
        },
        saveSettings() {
            // 保存设置到 Vuex
            this.setSettings(this.settings).then(() => {
                this.isSettingsDialogVisible = false;
            });
        },
        cancelSettings() {
            this.isSettingsDialogVisible = false;
        },
        async resetSettings() {
            try {
                await this.$confirm(
                    this.$t('headbar.settings.resetConfirm'),
                    this.$t('headbar.settings.resetTitle'),
                    {
                        confirmButtonText: this.$t('headbar.settings.resetConfirmButton'),
                        cancelButtonText: this.$t('headbar.settings.resetCancelButton'),
                        type: 'warning'
                    }
                );

                await this.resetToDefault();
                this.$message({
                    type: 'success',
                    message: this.$t('headbar.settings.resetSuccess')
                });
            } catch {
                // 用户取消操作
            }
        },
        handleLanguageChange(lang) {
            this.currentLanguage = lang;
            this.$i18n.locale = lang;
            localStorage.setItem('language', lang);
        },
        setMode(mode) {
            this.changeMode(mode);
        },
        getModeIcon(mode) {
            const icons = {
                'piano-roll': 'el-icon-menu',
                'guitar-tablature': 'el-icon-s-grid'
            };
            return icons[mode];
        },
        handleFileCommand(command) {
            switch (command) {
                case "import-txt":
                    this.importTxt();
                    break;
                case "export-svg":
                    this.$emit("export-svg");   // tablaturebar.vue
                    break;
                case "export-pdf":
                    this.$emit("export-pdf");   // tablaturebar.vue
                    break;
                case "export-txt":
                    this.$emit("export-txt");   // sidebar.vue
                    break;
                case "jianpu-converter":
                    this.openJianpuConverter();
                    break;
            }
        },
        importTxt() {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = '.txt';

            input.onchange = (e) => {
                const file = e.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        const content = event.target.result;
                        this.$emit('import-txt', content);
                    };
                    reader.readAsText(file);
                }
            };

            input.click();
        },
        toggleLayout() {
            const modes = ['split', 'tablature', 'sidebar'];
            const currentIndex = modes.indexOf(this.layoutMode);
            const nextIndex = (currentIndex + 1) % modes.length;
            this.$store.commit('setLayoutMode', modes[nextIndex]);
        },

        convertJianpu() {
            // 重置previousNotes
            this.previousNotes = [];

            // 移除所有空白字符，然后按空格分割
            const notes = this.jianpuInput.replace(/\s+/g, ' ').trim().split(' ');

            let jianzipuNotation = '';

            notes.forEach((noteStr, index) => {
                // 解析简谱音符
                const parsedNote = this.parseJianpuNote(noteStr);
                console.log(parsedNote)

                // 转换为减字谱音符
                const jianzipuNote = this.convertNoteToJianzhapu(parsedNote);

                jianzipuNotation += jianzipuNote;

                // 添加空格分隔
                if (index < notes.length - 1) {
                    jianzipuNotation += ' ';
                }
            });

            // 构建完整的减字谱格式
            const fullNotation = `= Header Section 描述头定义
B: <>
D: F
Z: Jianpu Converted

= Notes 谱子
${jianzipuNotation}

= Lyrics 歌词
`;
            // 发送事件到父组件
            this.$emit('update-notation', fullNotation);

            // 关闭对话框
            this.showJianpuConverterDialog = false;
        },

        parseJianpuNote(noteStr) {
            // 处理低音和高音
            const lowOctaveCount = (noteStr.match(/,/g) || []).length;
            const highOctaveCount = (noteStr.match(/'/g) || []).length;

            // 提取基础音高和节奏符号
            const basePitch = parseInt(noteStr.replace(/[,'.\/\-]/g, ''), 10);
            const rhythmSymbols = (noteStr.match(/[-./]/g) || []).join('');

            return {
                basePitch,
                octave: highOctaveCount - lowOctaveCount,
                rhythmSymbols
            };
        },

        convertNoteToJianzhapu(note) {
            // 在音位映射表中查找对应的弦和徽
            const matchedPosition = findPitchPositions(note);

            // 构建减字谱音符
            // 确定右手技巧
            const rightHandTechnique = this.determineRightHandTechnique(
                matchedPosition,
                note
            );

            return `${rightHandTechnique || ''}${matchedPosition.string}${matchedPosition.hui}${note.rhythmSymbols}`;
        },

        getRandomRightHandTechnique(beatDuration) {
            // 随机选择右手技巧
            const isIntegerOrHalf = Number.isInteger(this.totalDuration - beatDuration) || 
                            ((this.totalDuration - beatDuration) % 1 === 0.5);

            const technique = isIntegerOrHalf ? '勾' : '挑';
            console.log(this.totalDuration, isIntegerOrHalf)
            return technique;
        },


        determineRightHandTechnique(matchedPosition, currentNote) {
            // 解析节奏符号的拍数
            const beatDuration = this.parseBeatDuration(currentNote.rhythmSymbols);
            this.totalDuration += beatDuration;

            // 如果是第一个音，正常选择技巧
            if (this.previousNotes.length === 0) {
                this.previousNotes.push({
                    position: matchedPosition,
                    beatDuration: beatDuration
                });
                return this.getRandomRightHandTechnique(beatDuration);
            }

            // 检查是否在同一根弦上
            const lastNote = this.previousNotes[this.previousNotes.length - 1];
            const isSameString = lastNote.position.string === matchedPosition.string;

            // 计算连续音的拍数
            const totalBeatDuration = this.calculateTotalBeatDuration(this.previousNotes) + beatDuration;

            // 判断是否满足特殊条件
            if (isSameString &&
                this.previousNotes.length <= 4 &&
                totalBeatDuration < 2) {

                // 更新previousNotes
                this.previousNotes.push({
                    position: matchedPosition,
                    beatDuration: beatDuration
                });

                // 返回null（不记录右手技巧）
                return null;
            }

            // 重置previousNotes并开始新的序列
            this.previousNotes = [{
                position: matchedPosition,
                beatDuration: beatDuration
            }];
            
            // 正常选择技巧
            return this.getRandomRightHandTechnique(beatDuration);
        },

        parseBeatDuration(rhythmSymbols) {
            let duration = 1;
            for (const char of rhythmSymbols.split('')) {
                if (char === "-") duration += 1; // 延音
                if (char === "/") duration /= 2; // 减半
                if (char === ".") duration += duration / 2; // 附点
            }

            return duration;
        },

        calculateTotalBeatDuration(notes) {
            return notes.reduce((total, note) => total + note.beatDuration, 0);
        }

    }
};
</script>

<style scoped lang="scss">
.headbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 40px;
    background-color: #ffffff;
    flex-wrap: wrap;
}

.left-buttons {
    display: flex;
    align-items: center;
}

.right-buttons {
    display: flex;
    align-items: right;
}

.mode-switch {
    margin-left: 20px;
    margin-right: 20px;
}

.headbar-button {
    padding: 6px 12px;
    margin-right: 60px;
    font-size: 16px;
    color: #333;
    background: none;
    border: none;
    cursor: pointer;
    position: relative;
    transition: color 0.3s;
}

.headbar-button:hover {
    color: #007bff;
}

.headbar-button.active::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: #007bff;
}

.layout-button {
    margin-right: 28px;
    color: #007bff;
    background-color: rgba(0, 123, 255, 0.1);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.layout-button:hover {
    background-color: rgba(0, 123, 255, 0.3);
}

.user-icon {
    font-size: 22px;
    /* margin-right: 20px; */
    color: #007bff;
    padding: 6px;
    border-radius: 50%;
    cursor: pointer;
    transition: color 0.3s, background-color 0.3s;
}

.user-icon:hover {
    color: #fff;
    background-color: #007bff;
}

.settings-dialog {
    .el-dialog__body {
        padding: 0;
    }

    .el-tabs {
        margin: -20px;
    }

    .settings-section {
        padding: 20px;

        &+.settings-section {
            margin-top: 20px;
        }

        .section-header {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            padding-bottom: 10px;
            border-bottom: 1px solid #ebeef5;

            i {
                font-size: 18px;
                margin-right: 8px;
                color: #409EFF;
            }

            span {
                font-size: 16px;
                font-weight: 500;
                color: #303133;
            }
        }

        .settings-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;

            .el-form-item {
                margin-bottom: 0;
                display: flex;
                align-items: center;

                .el-form-item__label {
                    width: 100px; // 固定标签宽度
                    text-align: right;
                    padding-right: 12px;
                    line-height: 32px;
                }

                .el-form-item__content {
                    flex: 1;

                    .el-input-number,
                    .el-select,
                    .el-color-picker {
                        width: 100%;

                        .el-color-picker__trigger {
                            width: 100%;
                            height: 32px; // 与其他输入框保持一致高度
                            padding: 2px;
                            border: 1px solid #DCDFE6;
                            border-radius: 4px;

                            &:hover {
                                border-color: #409EFF;
                            }

                            .el-color-picker__color {
                                border: none;
                                border-radius: 2px;

                                .el-color-picker__icon {
                                    display: none; // 移除默认图标使其更简洁
                                }
                            }

                            .el-color-picker__empty {
                                border-radius: 2px;
                            }
                        }
                    }
                }
            }
        }

        // 专门处理边距输入组
        .margin-inputs {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
        }

        // 底部按钮区
        .el-dialog__footer {
            padding: 16px 24px;
            border-top: 1px solid #ebeef5;

            .dialog-footer {
                .el-button {
                    padding: 8px 20px;
                    font-size: 14px;
                    border-radius: 4px;

                    &+.el-button {
                        margin-left: 12px;
                    }
                }
            }
        }
    }
}

.el-select {
    width: 100%;
}

// .mode-button {
//     display: flex;
//     align-items: center;
//     gap: 5px;
// }

::v-deep(.el-dropdown-menu) {
    font-size: 16px;
}

::v-deep(.el-dropdown-item) {
    font-size: 16px;
    padding: 10px 20px;
}

::v-deep(.el-dropdown-item:hover) {
    background-color: #f5f5f5;
    color: #007bff;
}

.language-dropdown {
    margin-left: 8px;
}

.active-language {
    color: #007bff;
    font-weight: 500;
}

::v-deep(.el-dropdown-menu__item.active-language:hover) {
    color: #007bff;
}

.mode-selector {
    margin: 0 20px;

    .el-button {
        padding: 8px 15px;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;

        i {
            font-size: 16px;
        }

        &:not(.el-button--primary) {
            &:hover {
                color: #007bff;
                border-color: #007bff;
            }
        }
    }
}
</style>